<template>
<div class="product_introduction">
  <div class="introduction_title">
    <span class="text">产品介绍
      <div class="title_h5_icon"><hm-img imgName="home_service_icon_06_h5_zh" imgClass="module_img_style"/></div>
    </span>
  </div>
  <!-- <div class="introduction_content">
      <div
       class="tab_items"
       v-for="item in tabList"
       :key="item.key"
       @click.stop="menuChange(item.key)"
       :class="{ tab_active: item.key === severTabKey }"
      >{{item.tabName}}
      </div>
  </div> -->
  <div class="my_tab" ref="myTabRef">
    <div class="my_tab_item" v-for="(item, index) in tabList" :key="index" :ref="`tab${item.key}Ref`" :class="{ active: item.key === severTabKey }">
        <div class="my_tab_text" @click="tabClick(item)">{{ item.tabName }}</div>
    </div>
  </div>
  <div class="introduction_skip_content">
    <transition name="moveCartoon" appear>
      <div style="height: 100%" v-show="severTabKey === '1'">
          <div class="content_text"><span class="gradual">企业级智慧税务综合管理平台</span></div>
          <div class="content_tips">为企业提供一站式智能税务管理<br/>和全税种自动计税一键申报服务</div>
          <div class="content_img"><hm-img type="images" imgName="product_images_37_h5_zh" imgClass="introduction_img_style"/></div>
          <div class="content_btn">
            <a-button @click.stop="toNewPage" type="left">产品详情</a-button>
              <a-button @click.stop="gotoTryout" type="right">申请试用</a-button>
          </div>
      </div>
    </transition>
    <transition name="moveCartoon" appear>
      <div style="height: 100%" v-show="severTabKey === '2'">
        <div class="content_img_two">
              <hm-img type="images" imgName="product_images_38_h5_zh" imgClass="introduction_img_style" />
              <div class="content_btn">
                  <a-button @click.stop="toNewPage" type="right">产品详情</a-button>
              </div>
        </div>
      </div>
    </transition>
      <transition name="moveCartoon" appear>
        <div style="height: 100%" v-show="severTabKey === '3'">
            <div class="content_text_three">专为小微企业打造的代账代税SaaS平台</div>
            <div class="content_img_three"><hm-img type="images" imgName="product_images_39_h5_zh" imgClass="introduction_img_style" :big="true" srcBigImage="product_images_big_h5_zh"/></div>
            <div class="content_btn"><a-button @click.stop="toNewPage" type="right">产品详情</a-button></div>
        </div>
      </transition>
      <transition name="moveCartoon" appear>
        <div style="height: 100%" v-show="severTabKey === '4'">
            <div class="content_text_four">
              <div>全面归集并实时更新</div>
              <div>最新政策法规和热点问题</div>
            </div>
            <div class="content_img_four"><hm-img type="images" imgName="product_images_40_h5_zh" imgClass="introduction_img_style" :big="true" srcBigImage="product_images_big2_h5_zh"/>
              <div class="content_btn"><a-button @click.stop="toNewPage" type="right">产品详情</a-button></div>
            </div>
        </div>
      </transition>
      <transition name="moveCartoon" appear>
        <div style="height: 100%" v-show="severTabKey === '5'">
            <div class="content_text_four">助力企业提高税务合规遵从度及信用评级</div>
            <div class="content_img_five"><hm-img type="images" imgName="product_images_41_h5_zh" imgClass="introduction_img_style" />
              <div class="content_btn"><a-button @click.stop="toNewPage" type="right">产品详情</a-button></div>
            </div>
        </div>
      </transition>
  </div>
</div>
</template>

<script>
const tabList = [
  {
    key: '1',
    tabName: '税纪云'
  },
  {
    key: '2',
    tabName: 'Taxcellent'
  },
  // {
  //   key: '3',
  //   tabName: '财纪云 Fincellent'
  // },
  {
    key: '4',
    tabName: '法规库'
  },
  {
    key: '5',
    tabName: '行业数据库'
  }
]
export default {
  name: '',
  props: {},
  components: {},
  data () {
    return {
      tabList,
      severTabKey: '1',
      loading: false
    }
  },
  filters: {},
  watch: {

  },
  computed: {

  },
  created () {

  },
  methods: {
    // tab点击
    tabClick (item) {
      this.severTabKey = item.key
      // 触发滑动方法
      this.scrollLeftTo(item.key)
    },
    // 滑动
    scrollLeftTo (name) {
      const ref = `tab${name}Ref`
      // 获取myTabRef的DOM元素，即类名为my_tab的标签
      const nav = this.$refs.myTabRef
      // 获取当前点击的某一个tab的的DOM元素，即类名为my_tab_item的标签
      const title = this.$refs[ref][0]
      // 计算位移偏差
      const to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2
      nav.scrollLeft = to
      console.log('%cscrollLeft', 'background-color: pink;', nav.scrollLeft)
      console.log('%cscrollLeft2', 'background-color: pink;', this.$refs[ref][0].$el)
    },
    toNewPage () {
      console.log('%ctoNewPage', 'background-color: pink;', this.severTabKey)
      let target = {}
      switch (this.severTabKey) {
        case '1':
          target = {name: 'product', params: {type: 'newTaxera'}}
          break
        case '2':
          target = {name: 'product', params: {type: 'taxcellent'}}
          break
        case '3':
          target = {name: 'product', params: {type: 'fincellent'}}
          break
        case '4':
          target = {name: 'product', params: {type: 'lawLibrary'}}
          break
        case '5':
          target = {name: 'product', params: {type: 'ibd'}}
          break
        default:
          break
      }
      this.$router.push(target)
    },
    gotoTryout () {
      this.$router.push({ name: 'tryOut' })
    }
  }
}
</script>

<style scoped lang='less'>
#hm-web {
.moveCartoon-enter-active {
    animation: move .5s;
}
.moveCartoon-leave-active {
    // animation: move 0s reverse;
}
@keyframes move {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
}
.product_introduction {
  width: 100%;
  height: auto;
  background-color: #F7F9FB;
  background-image: linear-gradient(180deg, #F2F8FF 60%, #F2F8FF 20%);
  .introduction_title {
    padding-top: 60px;
    margin-bottom: 48px;
    text-align: center;
    // background-color: #F7F9FB;
    .text {
      font-family: PingFangSC-Medium;
      font-size: 40px;
      color: #292F3A;
      letter-spacing: 2px;
      text-align: center;
      line-height: 60px;
      font-weight: 500;
      padding: 44px 0 60px;
      position: relative;
      .title_h5_icon {
        width: 32px;
        height: 32px;
        position: absolute;
        right: 0%;
        top: 0%;
        transform: translate(50%, 70%);
      }
    }
  }
  .my_tab {
      // height: 96px;
      // background: #FFFFFF;
      // line-height: 96px;
      display: flex;
      overflow-x: scroll;
      border-bottom: 1px solid #ccc;
      // box-shadow: 0px 8px 16px 0px rgba(206,214,230,0.3);
      scroll-behavior: smooth; //平稳的滑动效果
      // 隐藏滚动条
      &::-webkit-scrollbar {
          height: 0;
          width: 0;
          color: transparent;
      }
      /* 隐藏 X 轴滚动条上的滑块 */
        &::-webkit-scrollbar-thumb {
            background-color: transparent;
        }
        -ms-overflow-style: none;
        scrollbar-width: none;
      .my_tab_item {
        font-family: PingFangSC-Medium;
        padding: 0 24px;
        height: 88px;
        line-height: 88px;
        text-align: center;
        flex: 1 0 auto;
        font-size: 28px;
        color: #566073;
        letter-spacing: 0;
        font-weight: 500;
          &.active {
            color: #3E77FF;
            font-weight: 500;
            .my_tab_text {
              // border-bottom: 1px solid #236AFF;
                position: relative;
                &::after {
                    position: absolute;
                    left: 50%;
                    bottom: 0;
                    content: '';
                    width: 100%;
                    height: 4px;
                    background-color: #236AFF;
                    border-radius: 3px;
                    opacity: 1;
                    transform: translateX(-50%);
              }
            }
        }
    }
  }
  // .introduction_content {
  //   width: 1200px;
  //   margin: 0 auto;
  //   display: flex;
  //   justify-content: space-between;
  //   .tab_items {
  //     width: 214px;
  //     height: 56px;
  //     border: none;
  //     border-bottom: 1px solid #ccc;
  //     font-size: 18px;
  //     line-height: 56px;
  //     color: #292F3A;
  //     text-align: center;
  //     font-weight: 600;
  //     cursor: pointer;
  //     &:hover {
  //     border-bottom: 2px solid #3e77ff;
  //   }
  //   }
  //   .tab_active {
  //     color: #3E77FF;
  //     border-bottom: 2px solid #3e77ff;
  //   }
  // }
.introduction_skip_content {
    margin: 0 auto;
    text-align: center;
    height: 100%;
    overflow: hidden;
    .content_text {
      margin: 80px 0 40px;
      .gradual {
        font-size: 36px;
        color: #292F3A;
        letter-spacing: 0;
        line-height: 48px;
        font-weight: 500;
      }
    }
    .content_tips {
      font-size: 28px;
      color: #848D9E;
      letter-spacing: 0;
      line-height: 40px;
      font-weight: 400;
      margin: 0 auto;
      margin-bottom: 40px;
    }
    .content_img {
      width: 100%;
      height: auto;
      padding: 0 20px;
    }
    .content_img_two {
      width: 100%;
      height: auto;
      margin: 0 auto;
      margin-top: 80px;
      position: relative;
    }
    .content_text_three {
      margin: 80px 0 40px;
      font-size: 36px;
      color: #292F3A;
      letter-spacing: 0;
      text-align: center;
      line-height: 48px;
      font-weight: 500;
    }
    .content_img_three {
      width: 100%;
      height: auto;
    }
    .content_text_four {
      margin: 80px 0 40px;
      font-size: 36px;
      color: #292F3A;
      letter-spacing: 0;
      text-align: center;
      line-height: 48px;
      font-weight: 500;
    }
    .content_img_four {
      width: 100%;
      height: auto;
      position: relative;
    }
    .content_img_five {
      width: 100%;
      height: auto;
      position: relative;
    }
    .content_btn {
      margin: 40px 0 80px;
    }
  }
  /deep/.ant-btn-left {
    background-color: #FFFFFF;
    color: #3E77FF;;
    border-color: transparent;
    border: 2px solid rgba(62,119,255,1);
    margin-right: 40px;
  }
  /deep/.ant-btn-right {
    background: linear-gradient(90deg, #3E77FF, #3BA7FC, #68A4F2);
    color: #FFFFFF;
    border-color: transparent;
    border: 1px solid rgba(216,221,230,1);
  }
  /deep/.ant-btn {
    width: 200px;
    height: 80px;
    border-radius: 8px;
    // box-shadow: 0px 3px 4px 0px rgba(126,145,193,0.35);
    span {
      font-size: 28px;
      font-weight: 500;
    }
  }
}
}
</style>
<style lang="less">
  #hm-web {
    .introduction_img_style {
      width: 100%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/components/productIntroduction-h5.vue